import React from 'react';
import { BarChart3 } from 'lucide-react';

const MetricsBlock = ({ title, metrics }) => (
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
      <h4 className="font-medium text-gray-900 flex items-center gap-2">
        <BarChart3 className="w-4 h-4" />
        {title}
      </h4>
    </div>
    <div className="p-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {metrics.map((metric, index) => (
          <div
            key={index}
            className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-100 hover:shadow-md transition-shadow"
          >
            <p className="text-sm text-gray-600 mb-1">{metric.label}</p>
            <p className="text-2xl font-bold text-blue-900">
              {metric.format === 'number' ? metric.value.toLocaleString() : metric.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default MetricsBlock;
